module.exports = __webpack_public_path__ + "media/images/pt/efficacy-segment-39f33c1ce0faa753b5e9a283fd2bd6cb.jpg";